/*=========================================================================================
  File Name: moduleSubscriptionActions.js
  Description: Subscription Module Actions
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
==========================================================================================*/

import axios from "@/axios.js"

export default {
    fetchSubscription({ commit }, UUID) {
        return new Promise((resolve, reject) => {
            axios.get(`/api/subscription-management/subscriptions/${UUID}`)
                .then((response) => {
                    commit('SET_SUBSCRIPTION', response.data)
                    resolve(response)
                })
                .catch((error) => { reject(error) })
        })
    },
    updateSubscription({ commit }, subscriptionInfo) {
        return new Promise((resolve, reject) => {
            axios.put(`/api/subscription-management/subscriptions`, subscriptionInfo)
                .then((response) => {
                    resolve(response)
                })
                .catch((error) => { reject(error) })
        })
    },

}